import { BLUE, DARK, GOLD } from '../constants/colors';

export default function Slider({label,value,onChange,min,max,step=1,format,tooltip}){
  const pct=((value-min)/(max-min))*100;
  return(
    <div style={{marginBottom:22}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
        <div style={{display:"flex",alignItems:"center",gap:6}}>
          <label style={{fontSize:12,fontWeight:700,color:"#475569",fontFamily:"sans-serif"}}>{label}</label>
          {tooltip&&<span title={tooltip} style={{width:15,height:15,borderRadius:"50%",background:"#F1F5F9",display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:9,color:"#94a3b8",cursor:"help",fontFamily:"sans-serif"}}>?</span>}
        </div>
        <span style={{fontSize:15,fontWeight:800,color:BLUE,fontFamily:"sans-serif",minWidth:60,textAlign:"right"}}>{format?format(value):value}</span>
      </div>
      <div style={{position:"relative",height:36,display:"flex",alignItems:"center"}}>
        <div style={{position:"absolute",left:0,right:0,height:7,background:"#E2E8F0",borderRadius:99,pointerEvents:"none"}}/>
        <div style={{position:"absolute",left:0,height:7,width:`${pct}%`,background:`linear-gradient(90deg,${BLUE},${GOLD})`,borderRadius:99,pointerEvents:"none"}}/>
        <div style={{position:"absolute",left:`${pct}%`,width:20,height:20,borderRadius:"50%",background:"#fff",border:`3px solid ${BLUE}`,boxShadow:"0 2px 8px rgba(52,152,219,0.4)",pointerEvents:"none",transform:"translateX(-50%)"}}/>
        <input type="range" min={min} max={max} step={step} value={value} onChange={e=>onChange(Number(e.target.value))}
          style={{position:"absolute",inset:0,width:"100%",height:"100%",opacity:0,cursor:"pointer",margin:0,padding:0,zIndex:2}}/>
      </div>
      <div style={{display:"flex",justifyContent:"space-between",marginTop:2}}>
        <span style={{fontSize:10,color:"#94a3b8",fontFamily:"sans-serif"}}>{format?format(min):min}</span>
        <span style={{fontSize:10,color:"#94a3b8",fontFamily:"sans-serif"}}>{format?format(max):max}</span>
      </div>
    </div>
  );
}
